<template>
    <div class="global-notice" :class="classes">
        <eda-link :to="actionTarget">

            <div class="global-notice__content">
                <div class="global-notice__message">
                    {{ message }}
                </div>
                <div class="global-notice__action-label">
                    {{ actionLabel }}
                </div>
            </div>
        </eda-link>

    </div>

</template>

<script>
  import EdaLink from "./vLink"

  export default {
    name: "GlobalNotice",
    components: {
      EdaLink
    },
    props: {
      message: { type: String, default: "" },
      actionTarget: { type: String, default: "" },
      show: { type: Boolean, default: false },
      actionLabel: { type: String, default: "" },
      level: {
        type: String, default: "notice", validator: value => {
          return ["notice", "warning", "error"].includes(value);
        }
      }
    },
    computed: {
      classes() {
        let classes = ['global-notice--' + this.level];

        if (!this.show) {
          classes.push("global-notice--hidden");
        }
        return classes;
      }
    },
  }
</script>

<style lang="scss">
    .global-notice {
        color: white;
        font-size: 0.8em;
        padding: 1.5em;
        width: 100%;
        transition: 0.2s ease all;
        max-height: 10em;

        &--notice {
            background-color: #369c3e;
        }

        &--warning {
            background-color: orange;
        }

        &--error {
            background-color: #ff5858;
        }

        &--hidden {
            max-height: 0;
            padding-top: 0;
            overflow: hidden;
            padding-bottom: 0;
        }

        &__content {
            display: flex;
            justify-content: center;
        }

        &__action-label {
            font-weight: 600;
            color: white;
            border-bottom: 1px solid white;
        }

        &__message {
            padding-right: 1em;
            color: white;
        }

    }

</style>